import {withStyles} from "@material-ui/core";
import PopoverBase from "@material-ui/core/Popover";

export const Popover = withStyles({
    paper: {
        overflow: 'visible',
        backgroundColor: 'transparent'
    }
})(PopoverBase)